import React from 'react'
import { useFeature } from 'common/feature-togglings/features'
import { Features } from 'common/features'

export interface Props {
    feature: Features
    on: () => React.ReactElement<any> | null
    off?: () => React.ReactElement<any> | null
}

export const FeatureToggle: React.FC<Props> = ({ feature, on, off }) => {
    const isEnabled = useFeature(feature)

    if (isEnabled) {
        return on()
    }

    if (off) {
        return off()
    }

    return null
}
FeatureToggle.displayName = 'FeatureToggle'
